import { ClickAwayListener } from '@material-ui/core';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Permissions } from '../../models/enums/permissions';
import { setOverridePermissions } from '../../actions/userdata-actions';
import { PermissionsDialog } from '../../components/permissions-dialog/PermissionsDialog';
import { IApplicationState } from '../../store/IApplicationState';
import { AuthenticationManager } from '../../utils/auth-manager';
import './Userbug.scss';
import { navigateToPage } from '../../utils/history';
import { Routes } from '../../utils/app-constants';

declare const CI_APP_VERSION: string;

export const Userbug = () => {

    const dispatch = useDispatch();
    const user = useSelector((state : IApplicationState) => state.userdata.user);
    const roles = useSelector((state : IApplicationState) => state.userdata.user.permissions);
    const [isOpen, setIsOpen] = React.useState(false);

    const logout = (e: any) => {
        e.preventDefault();
        AuthenticationManager.signOut();
    };

    const showUser = (e: any) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    };

    const clickAwayHandler = (e: any) => {

        const ele = document.getElementById('override-section');

        if (e && 
            e.target && 
            e.target.classList && 
            e.target.classList.value && 
            e.target.classList.value.indexOf('MuiBackdrop') > -1) {
            if (isOpen) {
                setIsOpen(false);
            }
        }
        else if (ele && ele.contains(e.target)) {
            // do nothing
        }
        else if (isOpen) {
            setIsOpen(false);
        }
    };

    const overridePermissions = (newPerms : Permissions[]) => {
        dispatch(setOverridePermissions(newPerms));
    };

    const _getDisplayName = () => {
        if (user && user.firstName && user.lastName) {
            return `${ user.firstName } ${ user.lastName }`;
        }
        return '';
    };

    // The first letters of the first and last name, which is what the round picture of the person says
    const _getInitials = () => {
        if (user && user.firstName && user.lastName) {
            return `${ user.firstName[0] }${ user.lastName[0] }`.toUpperCase();
        }
        return '';
    };

    return user
            ? <div className="user-bugs">
                <ClickAwayListener key="userbug-clickaway-1" onClickAway={ clickAwayHandler }>
                    <span className="user-bug-menu">
                        <button 
                            id="user-bug" 
                            type="button"
                            title={ _getDisplayName() }
                            aria-haspopup="true"
                            aria-expanded={ isOpen }
                            onClick={ showUser }>
                                <span className="user-initials">{ _getInitials() || <i className="la la-user"/> }</span>
                                <span className="user-name">{ _getDisplayName() }</span>
                        </button>
                        {
                            isOpen 
                                ? <div className="dropdown-menu show">
                                    <PermissionsDialog 
                                        overridePermissions={ overridePermissions }
                                        roles={ roles } />
                                    <button onClick={  logout } className="btn">Sign out</button>
                                    <p className="user-version">Version { CI_APP_VERSION }</p>
                                </div>
                                : ''
                        }
                    </span>
                </ClickAwayListener>
                <button
                    type="button"
                    className="user-signout"
                    title="Sign out"
                    aria-label="Sign out"
                    onClick={ logout }>
                    <i className="la la-sign-out"/>
                </button>
            </div>
            : null;
};
